export default __webpack_public_path__ + "static/media/drone3.c4158fe8.jpg";